import { makeStyles } from '@material-ui/core/styles';
import { styleBreakMobile, styleBreakSmallMobile, styleBreakDesktop } from '../components/utilities/layouts/Globals';
import { getStyle, mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { COLOR_WHITE } from '../components/utilities/Material';

export const getDoneBackgroundColor = theme => {
    return getStyle({ ned: COLOR_WHITE, watchman: theme.palette.background.default });
};

export const TaskHomeStyle = (stylesOverride) => {
    return makeStyles(theme => {
        /* Default styles */
        const styles = {
            timeUntilBox: {
                background: theme.palette.info.main,
                color: theme.palette.info.contrastText,
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
            },
            timeUntilBoxWarning: {
                background: theme.palette.warning.main,
                color: theme.palette.warning.contrastText,
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
            },
            greetingTextTypography: {
                marginBottom: theme.spacing(0.5),
            },
            introSection: {
                marginTop: theme.spacing(8),
                [styleBreakDesktop(theme)]: {
                    marginTop: theme.spacing(9),
                    paddingBottom: theme.spacing(2),
                },
            },
            subPageBox: {
                // Fixed dimensions required to achieve the overlap of the oval shape
                height: '240px',
                width: '2755px',
                [styleBreakMobile(theme)]: {
                    height: '200px',
                    width: '1500px',
                },
                borderRadius: '50%',
                backgroundColor: theme.palette.primary.light,
                zIndex: '-1',
                position: 'absolute',
                top: theme.spacing(11),
                transform: 'translateY(-50%)',
                boxSizing: 'border-box',
            },
            subPageBoxBigScreen: {
                top: '70px',
            },
            viewDoctorNoteTitle: {
                marginTop: theme.spacing(7),
                marginBottom: theme.spacing(1),
                [styleBreakDesktop(theme)]: {
                    marginTop: theme.spacing(8.25),
                    marginBottom: theme.spacing(2),
                },
                [styleBreakSmallMobile(theme)]: {
                    marginTop: theme.spacing(4),
                },
            },
            viewDoctorNoteTitleBigMobileScreen: {
                marginTop: theme.spacing(8),
            },
            subsection: {
                display: 'flex',
                justifyContent: 'center',
            },
            instructionBox: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingTop: '32px',
                [styleBreakMobile(theme)]: {
                    marginLeft: theme.spacing(3),
                    marginRight: theme.spacing(3),
                },
                [styleBreakSmallMobile(theme)]: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2),
                },
            },
            fontWeight500: {
                fontWeight: '500',
            },
            TaskTitle: {
                marginBottom: theme.spacing(0.5),
            },
            overDueTextColor: {
                color: theme.palette.warning.contrastText,
            },
            cardListBox: {
                marginBottom: theme.spacing(2),
            },
        };
    
        /* Add watchman specific styles */
        let watchmanStyles = {
            /* timeUntilBox */
            timeUntilBox: {
                background: theme.palette.primary.light,
            },
            /* timeUntilBoxWarning */
            timeUntilBoxWarning: {
                background: theme.palette.error.main,
            },
        };
        // merge
        watchmanStyles = mergeStyles(cloneDeep(styles), watchmanStyles);
    
        const stylesMap = {
            ned: styles,
            watchman: watchmanStyles,
        };
    
        return mergeStyles(cloneDeep(getStyle(stylesMap)), stylesOverride || {});
    });
};
